import moment from 'moment-timezone';

export function timeGuardForLegalReasons(fromHour: number, toHour: number): boolean {
  const now = moment.tz('Europe/Vilnius');
  const fromTime = now.clone().hour(fromHour).minute(0).second(0);
  const toTime = now.clone().hour(toHour).minute(0).second(0);
  now.hours() > toHour
    ? toTime.add(1, 'days')
    : fromTime.subtract(1, 'days');

  return now.isAfter(fromTime) && now.isBefore(toTime);
}
